package app.nestbridge.domain.identity.usecase

import app.nestbridge.domain.identity.model.User
import app.nestbridge.domain.identity.service.UserService
import me.tatarka.inject.annotations.Inject

@Inject
class SaveUserUseCase(
    private val userService: UserService,
) {
    suspend operator fun invoke(user: User): User = userService.save(user)
}
